export { default as InsuranceOrderingListTemplate } from './InsuranceOrderingListTemplate';
export { default as InsuranceOrderingEditTemplate } from './InsuranceOrderingEditTemplate'; 
export { default as InsuranceOrderingUploadTemplate } from './InsuranceOrderingUploadTemplate'; 